"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _auth = require("./auth.service");
Object.keys(_auth).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _auth[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _auth[key];
    }
  });
});
var _organization = require("./organization.service");
Object.keys(_organization).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _organization[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _organization[key];
    }
  });
});
var _assets = require("./assets.service");
Object.keys(_assets).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _assets[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _assets[key];
    }
  });
});
var _businessunit = require("./businessunit.service");
Object.keys(_businessunit).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _businessunit[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _businessunit[key];
    }
  });
});
var _users = require("./users.service");
Object.keys(_users).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _users[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _users[key];
    }
  });
});
var _consumers = require("./consumers.service");
Object.keys(_consumers).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _consumers[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _consumers[key];
    }
  });
});
var _dashboard = require("./dashboard.service");
Object.keys(_dashboard).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _dashboard[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _dashboard[key];
    }
  });
});
var _purchaseplan = require("./purchaseplan.service");
Object.keys(_purchaseplan).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _purchaseplan[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _purchaseplan[key];
    }
  });
});
var _billing = require("./billing.service");
Object.keys(_billing).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _billing[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _billing[key];
    }
  });
});
var _others = require("./others.service");
Object.keys(_others).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _others[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _others[key];
    }
  });
});
var _batchProcessing = require("./batch-processing.service");
Object.keys(_batchProcessing).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _batchProcessing[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _batchProcessing[key];
    }
  });
});
var _monitor = require("./monitor.service");
Object.keys(_monitor).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _monitor[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _monitor[key];
    }
  });
});
var _monitoring = require("./monitoring.service");
Object.keys(_monitoring).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _monitoring[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _monitoring[key];
    }
  });
});
var _personalConsult = require("./personal-consult.service");
Object.keys(_personalConsult).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _personalConsult[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _personalConsult[key];
    }
  });
});
var _openbank = require("./openbank.service");
Object.keys(_openbank).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _openbank[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _openbank[key];
    }
  });
});